var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.49998C6.20156 1.49998 1.5 6.20155 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20155 17.7984 1.49998 12 1.49998ZM12 20.7187C7.18594 20.7187 3.28125 16.814 3.28125 12C3.28125 7.18592 7.18594 3.28123 12 3.28123C16.8141 3.28123 20.7188 7.18592 20.7188 12C20.7188 16.814 16.8141 20.7187 12 20.7187Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0945 14.9671L12.7523 12.5507V6.74998C12.7523 6.64686 12.668 6.56248 12.5648 6.56248H11.4375C11.3344 6.56248 11.25 6.64686 11.25 6.74998V13.2047C11.25 13.2656 11.2781 13.3218 11.3273 13.357L15.2039 16.1835C15.2883 16.2445 15.4055 16.2257 15.4664 16.1437L16.1367 15.2296C16.1976 15.1429 16.1789 15.0257 16.0945 14.9671Z",
    fill: "#DBDBDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.8e3648c1a399cf95b133c8298c08e90f.svg";
export { ForwardRef as ReactComponent };